import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appOtpNumber]'
})
export class OtpNumberDirective implements OnInit {
  @Input() disabledNumberOnly: boolean;
  constructor(
    private readonly _elRef: ElementRef,
    private readonly _renderer: Renderer2
  ) {}

  ngOnInit() {
    if (!this.disabledNumberOnly) {
      this._renderer.setAttribute(
        this._elRef.nativeElement,
        'onkeypress',
        'return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 0'
      );
    }
  }
}
